// extracted by mini-css-extract-plugin
export default {"logo_box":"index_logo_box_K6UxM","logo_main":"index_logo_main_Z8z6H","logo_link":"index_logo_link_myS7k","time":"index_time_MUAXP"};